import { GalleryEndpoints } from "../api/admin/gallery.endpoints";
import APIrequest from "../lib/axios"

export const GalleryService = {
    async createGallery(data) {
        try {
            const payload = {
                ...GalleryEndpoints.createGallery,
                bodyData: data
            }
            const response = await APIrequest(payload);
            return response.data
        } catch (error) {
            throw error;
        }
    },
    async getAllGallery() {
        try {
            const payload = {
                ...GalleryEndpoints.getAllGallery,
            }
            const response = await APIrequest(payload);
            return response.data
        } catch (error) {
            throw error;
        }
    },
    async getGallery(id) {
        try {
            const payload = {
                ...GalleryEndpoints.getGallery,
                url: GalleryEndpoints.getGallery.url.replace(":id", id)
            }
            const response = await APIrequest(payload);
            return response.data
        } catch (error) {
            throw error;
        }
    },
    async updateGallery(id, data) {
        try {
            const payload = {
                ...GalleryEndpoints.updateGallery,
                url: GalleryEndpoints.updateGallery.url.replace(":id", id),
                bodyData: data
            }
            const response = await APIrequest(payload);
            return response.data
        } catch (error) {
            throw error;
        }
    },
    async deleteGallery(id) {
        try {
            const payload = {
                ...GalleryEndpoints.deleteGallery,
                url: GalleryEndpoints.deleteGallery.url.replace(":id", id)
            }
            const response = await APIrequest(payload);
            return response.data
        } catch (error) {
            throw error;
        }
    },
}
